module.exports = __webpack_public_path__ + "img/people-pants.1ca3b678.svg";